import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M19 9V6a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M3 11v5a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-5a2 2 0 0 0-4 0v2H7v-2a2 2 0 0 0-4 0Z",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Path, { d: "M5 18v2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M19 18v2", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Armchair";
const Armchair = memo(themed(Icon));
export {
  Armchair
};
//# sourceMappingURL=armchair.js.map
